import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import {StickyTable, Row, Cell} from 'react-sticky-table';
import Tooltip from '@material-ui/core/Tooltip';
import { compose } from 'underscore';
import Button from '@material-ui/core/Button';
import { withTranslation } from 'react-i18next';
import { api_host, api_auth } from '../../../../../common/globals/constants';
import icons from '../../../../../theme/icons.js';
import { lista_estados } from '../../../../../data/status_error_icons.js';
import { reportFetchError } from '../../../../../observability/rum';
class ObjectiveCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            objective: this.props.objectivesList,
            nodesIdList: this.props.nodesIdList,
            isLoading: true,
            loadError: false
        }
    }
    componentDidMount() {
        this.getDataFromAPI();
    } 
    getDataFromAPI = (objectiveId) => {
        
        const {objective, nodesIdList} = this.state
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        var monitors = objective.Monitores
        var steps = objective.Pasos
        var interval = objective.intervalo_id
        Promise.all([
            fetch(api_host+`/reporte/online/indicadores/getLastStatusObjectiveByNode/?user=${user}&objetivoId=${objective.objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&timestamp=${new Date().getTime()}`)
        ])
        .then(([res1]) => {
            return Promise.all([res1.json()])
        })
        .then(([res1]) => {
            //.then(response => response.json())
            //.then(myJson => { 
                let cell = []
                Object(nodesIdList).map((node, orden)=>{
                    var ok = false
                    var cellData = {}
                    Object(res1.nodos).map((nodeStatus, orden)=>{
                        if (node == nodeStatus.nodo_id && !ok){
                            if (nodeStatus.paso != ''){
                                cellData['step'] = nodeStatus.paso.nombre_paso
                            } else {
                                cellData['step'] = ''
                            }
                            cellData['status'] = nodeStatus.status
                            cellData['code'] = nodeStatus.codigo
                            if (nodeStatus.duracion >= 86400){
                                var newDate = new Date(parseInt(nodeStatus.duracion) * 1000)
                                var day = parseInt(newDate.getDate())
                                cellData['duration'] = day + ' día(s) ' + new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                            }else{
                                cellData['duration'] = new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                            }
                            var date = nodeStatus.fecha_tz.replace('T',' ').substr(0, 19)
                            var dateYear = date.substr(0, 10)
                            var dateYYYY = dateYear.substr(0, 4)
                            var datemm = dateYear.substr(5, 2)
                            var datedd = dateYear.substr(8, 9)
                            cellData['date'] = date.substr(11, 19)+' '+datedd+'-'+datemm+'-'+dateYYYY
                            var colorEvent = '#41B900'    
                            var icon = <i style={{...icons.sprite, ...icons.spriteOK, zoom: "normal", scale: "0.1", transform: "none"}}/> 
                            var nameEvent = 'Ok'                 
                            if(nodeStatus.status === "no_monitoreo"){
                                icon = <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO, zoom: "normal", scale: "0.1", transform: "none"}}/>
                                colorEvent = ' #A9A9A9'
                                nameEvent = 'Periodo sin monitoreo' 
                            }else if(nodeStatus.status === "downtime"){
                                colorEvent = '#C2272D'
                                if (nodeStatus.codigo in lista_estados){
                                    var icon = lista_estados[nodeStatus.codigo].icono
                                    icon = <i style={{...icons.sprite, ...icons[icon], zoom: "normal", scale: "0.1", transform: "none"}}/>
                                    nameEvent = lista_estados[nodeStatus.codigo].nombre 
                                } else {
                                    icon = <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE, zoom: "normal", scale: "0.1", transform: "none"}}/>
                                    nameEvent = 'Error' 
                                }
                            } 
                            cellData['nameEvent'] = nameEvent
                            cellData['icon'] = icon
                            cellData['color'] = colorEvent
                            cell.push(cellData)
                            ok = true
                        } 
                    })
                    if (!ok){
                        cellData['status'] = ""
                        cellData['code'] = ""
                        cellData['duration'] = ""
                        cellData['color'] = ""
                        cellData['icon'] = ""
                        cellData['step'] = ""
                        cell.push(cellData)
                    }
                })
                this.setState({cells: cell, isLoading: false});
            })
        .catch((error) => {
            reportFetchError('QuickViewIspObjectiveCell', error)
            let cell = Object(nodesIdList).map(() => ({status: "", code: "", duration: "", color: "", icon: "", step: ""}))
            this.setState({cells: cell, isLoading: false, loadError: true});
        })
        
    }
    processData = (externalData) => {
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
    };
    
    render() {
        const {isLoading, loadError, cells, objective} = this.state
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (!isLoading)  {
            return  <Row>
                        <Cell style={{maxWidth:'360px', minWidth:'360px', backgroundColor: objective.color_custom, color:'white', borderBottom: "2px solid #e4dede", 
                                                            left: 0, position: "sticky", zIndex: 2}}>
                            <Tooltip title={<div>
                                                <Typography variant="h5" style={{color:'white'}}>{objective.nombre}</Typography>
                                                </div>}>
                                <Button id={objective.objetivo_id} value={objective.nombre} onClick={this.props.handleOpenObjectiveModal}>
                                    <Typography variant="h6" style={{color:'white'}}>{objective.nombre.substr(0,50)}</Typography>
                                </Button>
                            </Tooltip>
                            {loadError ?
                                <Typography variant="caption" style={{color:'white', display:'block', paddingLeft:'8px'}}>{t('text.load-error')}</Typography>
                            : null}
                        </Cell>
                        {Object(cells).map(cell=>(
                            cell.icon != "" ? <Tooltip 
                                title={<div>
                                    <Typography variant="h4" style={{color:'white'}}>{cell.nameEvent}</Typography>
                                    <Typography variant="h6" style={{color:'white'}}>{t('quickview-compact.popover.text.date')+": "+cell.date}</Typography>
                                    <Typography variant="h6" style={{color:'white'}}>{t('quickview-compact.popover.text.duration')+": "+cell.duration}</Typography>
                                    {cell.step != '' ?<Typography variant="h6" style={{color:'white'}}>{t('quickview-compact.popover.error.text.error-step')+": "+cell.step}</Typography>:null}
                                    </div>} 
                                placement="bottom" arrow>
                                <Cell style={{maxWidth:'130px', minWidth:'130px', borderBottom: "2px solid #d4d4d4", borderRight: "2px solid #e4dede", backgroundColor: '#e9e9e9'}}>
                                    <Typography style={{height:"25px", paddingLeft:"40%", paddingTop: "5px"}}>
                                        {cell.icon}
                                    </Typography>
                                </Cell>
                            </Tooltip>
                            : <Cell style={{maxWidth:'130px', minWidth:'130px', borderBottom: "2px solid #d4d4d4", borderRight: "2px solid #e4dede", backgroundColor: '#e9e9e9'}}>
                                <Typography style={{height:"25px", paddingLeft:"40%", paddingTop: "5px"}}>
                                    {cell.icon}
                                </Typography>
                                </Cell>
                        ))}
                    </Row>          
            
        } else {
            return <div>      
                    <Typography
                        
                        variant="h5">
                        <CircularProgress
                            variant="indeterminate"      
                            size={24}
                            thickness={4}                            
                        />
                        {t('text.loading')}
                    </Typography>        
                </div>     
        }
    }
}
export default compose(withTranslation())(ObjectiveCell);